import {
  AccountingReferenceBreakdownItem,
  SiteBreakdownItem,
  UserAnalyticsDetailsItem,
} from '~/data/analytics';

import { i18n } from '~/utils';

export const USAGE_TABS = ['users', 'sites', 'costCenters'] as const;

export type DateRangeNameOption = '7-days' | '30-days' | '90-days' | '180-days';

export type RowModel = UserAnalyticsDetailsItem &
  SiteBreakdownItem &
  AccountingReferenceBreakdownItem;

export const DATE_RANGE_OPTIONS: Record<DateRangeNameOption, string> = {
  '7-days': i18n.t(($) => $.date.range.last7Days, { ns: 'forms' }),
  '30-days': i18n.t(($) => $.date.range.last30Days, { ns: 'forms' }),
  '90-days': i18n.t(($) => $.date.range.last90Days, { ns: 'forms' }),
  '180-days': i18n.t(($) => $.date.range.last180Days, { ns: 'forms' }),
} as const;

export const DATE_RANGE_NAMES_ORDER: readonly DateRangeNameOption[] = [
  '7-days',
  '30-days',
  '90-days',
  '180-days',
] as const;

export const DELIVERY_NOTES_CHART_TYPE = ['absolute', 'relative'] as const;

export const CHART_COLORS = ['#95e5b7', '#e4e6ed'] as const; // 2nd color is filler bar color for percentage bars
export const CHART_SINGLE_DATASET_COLOR = '#c5c9d6' as const;
export const CHART_HOVER_COLOR = '#a7c3ff' as const;
